var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 6H11.375V3.75781C11.375 3.51172 11.2656 3.29297 11.1016 3.12891L8.99609 1.02344C8.83203 0.859375 8.61328 0.75 8.36719 0.75H3.44531C2.98047 0.75 2.625 1.16016 2.625 1.625V6H2.1875C0.957031 6 0 6.98438 0 8.1875V10.8125C0 11.0586 0.191406 11.25 0.4375 11.25H2.625V14.3125C2.625 14.5586 2.81641 14.75 3.0625 14.75H10.9375C11.1562 14.75 11.375 14.5586 11.375 14.3125V11.25H13.5625C13.7812 11.25 14 11.0586 14 10.8125V8.1875C14 6.98438 13.0156 6 11.8125 6ZM8.75 2.00781L10.1172 3.375H8.75V2.00781ZM3.5 1.625H7.875V3.375C7.875 3.86719 8.25781 4.25 8.75 4.25H10.5V6H3.5V1.625ZM10.5 13.875H3.5V11.25H10.5V13.875ZM13.125 10.375H0.875V8.1875C0.875 7.47656 1.44922 6.875 2.1875 6.875H11.8125C12.5234 6.875 13.125 7.47656 13.125 8.1875V10.375ZM10.9375 7.96875C10.5547 7.96875 10.2812 8.26953 10.2812 8.625C10.2812 9.00781 10.5547 9.28125 10.9375 9.28125C11.293 9.28125 11.5938 9.00781 11.5938 8.625C11.5938 8.26953 11.293 7.96875 10.9375 7.96875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.12ebf32e2a299397bb5747501c266660.svg";
export { ForwardRef as ReactComponent };